module.exports = __webpack_public_path__ + "img/Q80B.4dc4debb.png";